module.exports = __webpack_public_path__ + "static/media/fabric_0003.e33a77ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/fabric_0003.jpg
// module id = 629
// module chunks = 0